import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import { Redirect, withRouter } from 'react-router-dom';
import gql from 'graphql-tag';
import _ from 'lodash';
import ScrollLock from 'react-scrolllock';

import quizQuestions from './quizQuestions';
import Quiz from './Quiz';
import Result from './Result';
import Header from '../NewProfile/Header';
import SideBarContent from '../SideBar/SideBarContent';
import './newexam.css';
import Modal from '../../artzu-ui/src/Modal';
import Button from '../../artzu-ui/src/Button';

// import './index.css';

class Exam extends Component {
  constructor(props) {
    super(props);

    this.state = {
      questionList: [],
      answersList: [],
      counter: 0,
      questionId: 1,
      question: '',
      answerOptions: [],
      answer: '',
      answersCount: {
        correct: 0,
        wrong1: 0,
        wrong2: 0,
        wrong3: 0
      },
      result: false,
      passed: false,
      score: 0,
      modal: false
    };
  }

  componentWillMount() {
    const shuffledQuestions = this.shuffleArray(quizQuestions);
    this.setState(
      {
        questionList: shuffledQuestions,
        answersList: _.times(shuffledQuestions.length, _.constant(null))
      },
      () => this.shuffleAnswers(this.state.questionList)
    );
    window.onbeforeunload = function() {
      return true;
    };
  }

  componentWillUnmount() {
    window.onbeforeunload = null;
  }

  setUserAnswer = (answer, callback) => {
    this.setState(
      state => ({
        answersCount: {
          ...state.answersCount,
          [answer]: state.answersCount[answer] + 1
        },
        answer
      }),
      callback
    );
  };

  setUserClick = (answer, callback) => {
    this.setState(
      state => ({
        answer
      }),
      callback
    );
  };

  setNextQuestion = () => {
    const { questionList, answersList } = this.state;
    const counter = this.state.counter + 1;
    const questionId = this.state.questionId + 1;
    const answer = answersList[counter] || '';
    this.setState({
      counter,
      questionId,
      question: questionList[counter].question,
      answerOptions: questionList[counter].answers,
      answer
    });
  };

  setPrevQuestion = () => {
    const { questionList, answersList } = this.state;
    const counter = this.state.counter - 1;
    const questionId = this.state.questionId - 1;
    const answer = answersList[counter];
    this.setState({
      counter,
      questionId,
      question: questionList[counter].question,
      answerOptions: questionList[counter].answers,
      answer
    });
  };

  // setResults = score => {
  //   this.setState({ result: true, score });
  //   if (score >= 16) {
  //     this.setState({ passed: true }, () => this.updateUser());
  //   }
  // };

  handleResults = () => {
    const { answersList } = this.state;
    let quizScore = 0;
    answersList.forEach(e => {
      e === 'correct' ? quizScore++ : null;
    });
    this.setState({ result: true, score: quizScore });
    if (quizScore >= 15) {
      this.setState({ passed: true }, () => this.updateUser());
    }
  };

  shuffleAnswers = questions => {
    const shuffledAnswerOptions = questions.map(question =>
      this.pushAllAboveToBack(this.shuffleArray(question.answers))
    );
    this.setState({
      question: questions[0].question,
      answerOptions: shuffledAnswerOptions[0]
    });
  };

  retakeExam = () => window.location.reload();

  // handleAnswerSelected = event => {
  //   const { questionId, questionList } = this.state;
  //   this.setUserClick(event, () => {
  //     console.log('clicked a choice', this.state);
  //   });
  // };

  handleAnswerSelected = event => {
    const { questionId, questionList } = this.state;
    this.setUserClick(event, () => {
      console.log('clicked a choice', this.state);
    });
  };

  handleClickNext = () => {
    const {
      questionId,
      questionList,
      answersList,
      answer,
      counter
    } = this.state;
    const newAnswersList = [...answersList];
    newAnswersList[counter] = answer;
    this.setState(state => ({
      answersList: newAnswersList
    }));
    if (questionId < questionList.length) {
      console.log('next quest');
      setTimeout(() => this.setNextQuestion(), 300);
    } else {
      console.log('ready to handle');
      setTimeout(() => this.handleResults(), 300);
    }
  };

  handleClickPrev = () => {
    const { questionId, answersList, counter, answer } = this.state;
    const newAnswersList = [...answersList];
    newAnswersList[counter] = answer;
    this.setState(state => ({
      answersList: newAnswersList
    }));
    if (questionId > 1) {
      setTimeout(() => this.setPrevQuestion(), 300);
    } else {
      console.log('first question, disabled');
    }
  };

  // handleAnswerSelected = event => {
  //   const { questionId, questionList } = this.state;
  //   this.setUserAnswer(event.currentTarget.value, () => {
  //     if (questionId < questionList.length) {
  //       setTimeout(() => this.setNextQuestion(), 300);
  //     } else {
  //       setTimeout(
  //         () => this.setResults(this.state.answersCount.correct),
  //         300
  //       );
  //     }
  //   });
  // };

  shuffleArray = array => {
    let currentIndex = array.length;
    let temporaryValue;
    let randomIndex;

    // While there remain elements to shuffle...
    while (currentIndex !== 0) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  };

  pushAllAboveToBack = array => {
    const index = _.findIndex(
      array,
      ({ content }) => content.split(' ')[0] === 'All'
    );
    if (index !== -1) {
      array.push(array[index]);
      array.splice(index, 1);
    }
    return array;
  };

  updateUser = () => {
    const { answersCount, score } = this.state;
    this.props.client.mutate({
      mutation: UPDATE_USER,
      variables: {
        userFields: {
          certification: 'plus_demo'
        },
        score
      }
    });
  };

  renderQuiz = () => (
    <Quiz
      answer={this.state.answer}
      answerOptions={this.state.answerOptions}
      questionId={this.state.questionId}
      question={this.state.question}
      questionTotal={this.state.questionList.length}
      onAnswerSelected={this.handleAnswerSelected}
      onNextButtonClicked={this.handleClickNext}
      onPrevButtonClicked={this.handleClickPrev}
    />
  );

  renderResult = () => {
    const { result, passed, score } = this.state;

    return (
      <Result
        quizResult={result}
        score={score}
        passed={passed}
        retakeExam={this.retakeExam}
      />
    );
  };

  render() {
    const { history } = this.props;
    const { modal } = this.state;
    return (
      <div className="container new-exam">
        {/examhtml/.test(window.location.href) ? null : (
          <Header
            persistentTitle
            title="Autzu PLUS Course"
            back
            onClick={() => {
              this.setState({ modal: true });
            }}
          />
        )}
        <Modal open={modal} className="new-exam__modal">
          <div className="new-exam__modal__content">
            {/* <StyledDiv> */}
            {/* <StyledPTag> */}
            <div className="new-exam__modal__content--div">
              You will lose your progress in the quiz if you leave now.
            </div>
            {/* </StyledPTag> */}
            <div className="new-exam__modal__content__buttons">
              <Button
                label="Cancel"
                color="#414141"
                padding="0"
                onClick={() => this.setState({ modal: false })}
              />
              <Button
                label="Leave Quiz"
                color="#128DFF"
                padding="0"
                onClick={() => history.goBack()}
              />
            </div>
            {/* </StyledDiv> */}
          </div>
        </Modal>
        <div className="new-exam__container">
          <div className="new-exam__sidebar">
            <SideBarContent
              status={this.props.status}
              signedIn={this.props.loggedIn}
            />
          </div>
          <div
            className="new-exam__body"
            style={
              /examhtml/.test(window.location.href)
                ? { marginTop: '0' }
                : null
            }>
            {this.state.result ? this.renderResult() : this.renderQuiz()}
          </div>
        </div>
      </div>
    );
  }
}

export default withApollo(withRouter(Exam));

const UPDATE_USER = gql`
  mutation updateUser($userFields: UserAttributes!, $score: Int!) {
    updateUser(userFields: $userFields) {
      user {
        email
      }
      errors {
        message
      }
    }
    createPlusOnboard(score: $score) {
      status
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/NewExam/index.js